import React, { useEffect, useState, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import LinkButton from "../../utils/LinkButton";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import cursosimg from "../../static/images/cursos_default.png";

function Cursos({ data }) {
  const [listCourses, setlistCourses] = useState([]);
  const [deleteCur, setdeleteCur] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  useEffect(() => {
    GetCourses();
  }, []);

  function GetCourses() {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .get("company-course/list-courses/" + data.companyProfileId, config)
      .then((result) => {
        setlistCourses(result.data);
      });
  }

  function SetTab() {
    document.getElementById("pills-tab2").setAttribute("class", "nav-link");
    document
      .getElementById("pills-tab1")
      .setAttribute("class", "nav-link active");
  }

  function modalDelete(id) {
    setdeleteCur(id);
    setShow(true);
  }

  function DeleteCourse() {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios.post("company-course/close/" + deleteCur, config).then((result) => {
      if (result.status === 200) {
        setShow(false);
        toast.success(result.data.message, {
          duration: 4000,
        });
        GetCourses();
      }
    });
  }

  let rol = localStorage.getItem("rol");
  let pathComplement = "";
  if (rol === "company") pathComplement = "/company";
  else pathComplement = "/CentroFormacion";

  return (
    <Fragment>
      <div className="content" style={{ width: "100%" }}>
        <div class="tab-content" id="pills-tabContent">
          <div className="bordered-box__header">
            <div className="bordered-box__header-title">TUS PUBLICACIONES</div>
            <div class="col-6 d-flex justify-content-end select-class">
              <label for="staticEmail" class="col-sm-10 col-form-label">
                Filtrar:
              </label>
              <select
                class="col-sm-2 form-select form-select-sm"
                aria-label="Default select example"
              >
                <option selected>Más reciente</option>
                <option value="1">Más antiguo</option>
              </select>
            </div>
          </div>
          <div class="courseList">
            <div class="mt-4 row">
              {listCourses.map((item, index) => (
                <div key={index} className="courseBox col-sm-6 p-4">
                  <div className="row">
                    <div className="col-sm-6 mt-2 mb-2">
                      <div className="border-gray img-Curso">
                        <img
                          src={
                            item.fotoCurso != null
                              ? item.fotoCurso
                              : cursosimg
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-5 mt-1 mb-2">
                      <p className="mb-1">
                        Nombre del curso: <br></br>
                        <span>{item.name}</span>
                      </p>
                      <p>
                        Temática: <br></br>
                        <span>{item.ubicacion}</span>
                      </p>
                      <div className="tab2btn d-inline">
                        <LinkButton
                          to={{
                            pathname: pathComplement + "/Formacion/Publica",
                            state: {
                              courseId: item.courseId,
                            },
                          }}
                          onClick={SetTab}
                          type="button"
                          className="btn btn-light"
                        >
                          Editar
                        </LinkButton>
                        <LinkButton
                          to={{
                            pathname: pathComplement + "/DetalleCurso",
                            state: {
                              courseId: item.courseId,
                            },
                          }}
                          type="button"
                          className="btn btn-info"
                        >
                          Ver
                        </LinkButton>
                      </div>
                    </div>
                    <div class="col-sm-1 mt-2 mb-2 text-center">
                      <i
                        class="fas fa-trash-alt trash"
                        onClick={() => modalDelete(item.courseId)}
                      ></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        keyboard={false}
        dialogClassName="kr-modal"
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__title text-center">Eliminar Curso</div>
              <div className="form__row">
                <div className="col-sm-12 ">
                  <label htmlFor="names">Desea eliminar este registro?</label>
                </div>
              </div>
              <div className="form__row">
                <button
                  className="btn btn--gradient btn__icon btn__icon--door"
                  onClick={() => DeleteCourse()}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default Cursos;
